;(function () {
	const productMarkers = () => {
		$('.js-product-markers__item').click(function () {
			$('.product-markers__img-box').css({
				borderTopLeftRadius: '0px',
				borderTopRightRadius: '0px',
			})

			$('.product-markers-for-mobile .js-product-markers__item-inner').each(function () {
				$(this).css({ display: 'none' })
			})

			$(
				`.product-markers-for-mobile .js-product-markers__item-inner[data-index='${$(this).data('index')}']`
			).css({ display: 'block' })
		})

		$('.js-product-markers__item').hover(
			function () {
				const marker = $(this)
				const tooltip = marker.find('.card-wrapper')
				const tooltipRect = tooltip[0].getBoundingClientRect()
				const boxRect = $('.product-markers__img-box')[0].getBoundingClientRect()

				if (tooltipRect.right > boxRect.right) marker.addClass('product-markers__card-goToLeft')
				if (tooltipRect.bottom >= boxRect.bottom) marker.addClass('product-markers__card-goToTop')
				if (tooltipRect.top <= boxRect.top) marker.addClass('product-markers__card-goToBottom')
			},
			function () {
				$(this).removeClass(
					'product-markers__card-goToLeft product-markers__card-goToTop product-markers__card-goToBottom'
				)
			}
		)
	}

	function initJournalSlider() {
		document.querySelectorAll('[data-jrnl-slider]').forEach(function (slider) {
			if (slider._jrnlInit) return
			slider._jrnlInit = true

			const slides = Array.from(slider.querySelectorAll('[data-jrnl-slide]'))
			const dots = Array.from(slider.querySelectorAll('[data-jrnl-dot]'))
			const prevBtn = slider.querySelector('[data-jrnl-prev]')
			const nextBtn = slider.querySelector('[data-jrnl-next]')
			let current = 0
			const modal = slider.querySelector('[data-jrnl-modal]')
			const modalContent = slider.querySelector('[data-jrnl-modal-content]')
			const modalClose = slider.querySelector('[data-jrnl-modal-close]')
			function closeAllPopups() { slider.querySelectorAll('.jrnl-slider__marker.is-open').forEach(function (m) { m.classList.remove('is-open') }) }
			function closeModalJ() { if (modal) { modal.classList.remove('is-active'); document.body.style.overflow = '' } }

			function goTo(index) {
				slides[current].classList.remove('jrnl-slider__slide--active')
				dots[current] && dots[current].classList.remove('jrnl-slider__dot--active')
				current = (index + slides.length) % slides.length
				slides[current].classList.add('jrnl-slider__slide--active')
				dots[current] && dots[current].classList.add('jrnl-slider__dot--active')
				closeAllPopups()
				closeModalJ()
			}

			prevBtn && prevBtn.addEventListener('click', function () { goTo(current - 1) })
			nextBtn && nextBtn.addEventListener('click', function () { goTo(current + 1) })
			dots.forEach(function (dot) {
				dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.jrnlDot, 10)) })
			})
             var pointerStartX = 0
			var isDragging = false
			var track = slider.querySelector('.jrnl-slider__track')
			var swipeTarget = track || slider
			swipeTarget.addEventListener('pointerdown', function (e) {
				pointerStartX = e.clientX
				isDragging = true
			})
			swipeTarget.addEventListener('pointerup', function (e) {
				if (!isDragging) return
				isDragging = false
				var diff = pointerStartX - e.clientX
				if (Math.abs(diff) > 40) {
					e.preventDefault()
					goTo(diff > 0 ? current + 1 : current - 1)
				}
			})
			swipeTarget.addEventListener('pointerleave', function () { isDragging = false })
			swipeTarget.addEventListener('pointercancel', function () { isDragging = false })
			slider.querySelectorAll('.jrnl-slider__marker').forEach(function (marker) {
				const popup = marker.querySelector('.jrnl-marker__popup')
				if (popup) popup.addEventListener('click', function (e) { e.stopPropagation() })
				marker.addEventListener('click', function (e) {
					e.stopPropagation()
					const isMobile = window.innerWidth <= 749
					if (isMobile && modal && popup) {
						modalContent.innerHTML = popup.innerHTML
						modal.classList.add('is-active')
						document.body.style.overflow = 'hidden'
					} else {
						const wasOpen = marker.classList.contains('is-open')
						closeAllPopups()
						if (!wasOpen) marker.classList.add('is-open')
					}
				})
			})
			modalClose && modalClose.addEventListener('click', closeModalJ)
			modal && modal.addEventListener('click', function (e) { if (e.target === modal) closeModalJ() })
			document.addEventListener('click', function (e) { if (!e.target.closest('[data-jrnl-slider]')) closeAllPopups() })
			document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAllPopups(); closeModalJ() } })
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		productMarkers()
		initJournalSlider()
	})
	document.addEventListener('shopify:section:load', function () {
		productMarkers()
		initJournalSlider()
	})
})()
